import {formatDateTime} from 'i18n/localeDateFormat';
import {i18n, TFunction} from 'i18next';
import React from 'react';
import {Requirement, RequirementStatus, VehicleProject} from 'types';

export const getProjectName = (item: VehicleProject, i18n: i18n) =>
	item.name && item.name.trim().length > 0
		? item.name
		: `${item.generation} | ${item.derivative} | ${formatDateTime(
				new Date(item.sopVsi),
				i18n,
		  )}`;

type NamedVariant = {name?: string | null} | null | undefined;

const getUniqueVariantNames = (
	items: VehicleProject[] | undefined,
	pick: (project: VehicleProject) => Array<NamedVariant> | null | undefined,
): string[] => {
	const names = (items ?? [])
		.flatMap(project => pick(project) ?? [])
		.map(v => v?.name?.trim())
		.filter((name): name is string => Boolean(name));

	return [...new Set(names)];
};
export const getBodyWorkVariants = (
	items: VehicleProject[] | undefined,
): string[] => getUniqueVariantNames(items, p => p.bodyworkVariants);

export const getDriveVariants = (
	items: VehicleProject[] | undefined,
): string[] => getUniqueVariantNames(items, p => p.driveVariants);

export const getTechnologyVariants = (
	items: VehicleProject[] | undefined,
): string[] =>
	getUniqueVariantNames(items, p =>
		p.technology ? [{name: p.technology}] : [],
	);

export const getEarliestPosEtVsi = (
	items: VehicleProject[] | undefined,
): string | undefined => {
	const dates = (items ?? [])
		.map(p => (p.posEtVsi ? new Date(p.posEtVsi as any) : null))
		.filter((d): d is Date => {
			if (d === null) {
				return false;
			}
			return !Number.isNaN(d.getTime());
		})
		.sort((a, b) => a.getTime() - b.getTime());
	return dates.length > 0 ? dates[0].toISOString() : undefined;
};
